<template>
    <div :class="{ 'v2': !v1, 'v1': v1 }">
        <button :type="type"
                :id="id"
                class="ssa-button"
                :class="{
                    'button-linkStyle': link,
                    'primary headlineSmall': !link,
                    large
                }"
                v-on="$listeners"
                :disabled="loading">
            <span v-if="!loading"><slot></slot></span>
            <IconBase v-if="loading"
                      class="loader-icon"
                      width="30"
                      height="16"
                      display="inline-flex"
                      iconName="loaderIcon"></IconBase>
        </button>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';

export default {
    name: 'Button',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        link: {
            type: Boolean,
            default: false
        },
        type: {
            type: String
        },
        id: {
            type: String
        },
        v1: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    components: { IconBase }
};
</script>

<style lang="scss" scoped>
.v2 {
    @import "~styles/styleGuide.V2";
    @import "~styles/buttons.V2.scss";

    .ssa-button.primary {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.v1 {
    @import "~styles/styleGuide";
    @import "~styles/buttons.scss";
}
</style>
